<template>
  <div>
    <div>
      <div class="m-logbg"></div>
    </div>
    <div>
      <el-row style="background-color: #34495e;opacity:0.85;" >
        <el-col :span="20" :offset="2">
          <div class="dw-header-main" >
            <el-row type="flex" justify="space-between" align="middle">
              <el-col :span="4" >
                <a href="/#/">
                  <el-image src="/static/diaowen/images/logo/LOGO.png" ></el-image>
                </a>
              </el-col>
              <el-col :span="16">
                <div style="padding-left: 60px;color: white;">工学云调查问卷系统 - V3.0</div>
              </el-col>
              <el-col :span="4" style="text-align: right;" >
                <div>
                  <div style="height: 80px;line-height: 80px;">
                    <el-button type="primary">登录</el-button>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import DwNavMenu from '@/components/layouts/DwNavMenu.vue'

export default {
  name: 'DwHeaderLogin',
  components: {
    'dw-nav-menu': DwNavMenu
  }
}
</script>

<style scoped>
.dw-header-main{
  padding: 0px;
}
.el-dropdown-link{
  color: white;
}
.m-logbg {
  position: absolute;
  z-index: 0;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/layouts/DwHeaderLogin.vue